export enum FileUploadStrings {
    UPLOAD_BUTTON_TEXT = 'Choose file',
    DROPZONE_TEXT = 'Drop file to upload',
    REMOVE_FILE_ARIA_LABEL = 'Remove file',
    LIMIT_SHOW_FEWER = 'Show fewer files',
    LIMIT_SHOW_MORE = 'Show more files',
    ERROR_ICON_ARIA_LABEL = 'Error',
    CONSTRAINT_TEXT = 'Requires .XLSX file.',
}

export const EXCEL_SHEET_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';